/*                                                          */
export const coerseFunctionOrValue = async <T, Args extends any[], F = never>(
  value: T | Promise<T> | ((...a: Args) => T | Promise<T>),
  fallback?: F,
  ...args: Args
): Promise<{ $: F } extends { $: never } ? T : Exclude<T, void | false | null> | F> => {
  const result =
    typeof value === "function" ? (value as (...a: Args) => T | Promise<T>)(...args) : value;
  return (typeof result === "string" || !!result ? result : fallback) as never;
};

/*                                                          */
export const noop = (v: any = {}): any => v;
